import { Avatar, Divider, Popover, Stack } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";

function MoreUsers({ anchorEl, handleClose, items }) {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="more-user-popover"
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <MDBox p={2}>
          {items.map((item, index) => (
            <>
              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar variant="circular" src={item.profilePicture} />
                <MDTypography>{item.name}</MDTypography>
              </Stack>
              {items.length - 1 !== index && <Divider sx={{ my: 1, backgroundColor: "#9b9b9b" }} />}
            </>
          ))}
        </MDBox>
      </Popover>
    </div>
  );
}

export default MoreUsers;
